import Nullstack from 'nullstack';
export default function IconBrandDenodo({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-denodo",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 11h2v2h-2z"
  }), "   ", Nullstack.element("path", {
    d: "M3.634 15.634l1.732 -1l1 1.732l-1.732 1z"
  }), "   ", Nullstack.element("path", {
    d: "M11 19h2v2h-2z"
  }), "   ", Nullstack.element("path", {
    d: "M18.634 14.634l1.732 1l-1 1.732l-1.732 -1z"
  }), "   ", Nullstack.element("path", {
    d: "M17.634 7.634l1.732 -1l1 1.732l-1.732 1z"
  }), "   ", Nullstack.element("path", {
    d: "M11 3h2v2h-2z"
  }), "   ", Nullstack.element("path", {
    d: "M3.634 8.366l1 -1.732l1.732 1l-1 1.732z"
  }), " ");
}